"use client";

// a common sign-up box

import React, { useEffect, useState } from 'react'

import { useLingui } from "@lingui/react/macro";

import { add } from 'bwax/query/simpleActions';
import { getCurrentUser, mobileLogin, passwordLogin } from 'bwax/query/userActions';

import getImageURL from 'bwax/util/getImageURL';

import TextInput from 'bwax-ui/components/inputs/TextInput';
import PasswordInput from "bwax-ui/components/inputs/PasswordInput";

import WeChatLoginQrCode from 'bwax-ui/components/WeChatLoginQrCode'

import Button, { iconButton, Pressable } from 'bwax-ui/components/Button';
import setTokenCookie from 'bwax-ui/setTokenCookieNext'

import { toast } from 'bwax-ui/components/Toast';

import { RiLockPasswordLine, RiWechat2Line, RiShieldKeyholeLine } from "react-icons/ri";
import { MdPhoneIphone } from "react-icons/md";

import { useTrack } from 'bwax-ui/track';
import { useRouter } from 'next/navigation';
import clsx from 'clsx';

import SamlLogin from './SamlLogin';

// 如果有用户，自动登入；
// 提供手机验证码和微信登入两种；

// 自动创建用户
// 显示用户协议和隐私政策

// 登录完后，返回 rt 参数指向的页面，或者 /

export default function LogOn(props) {

    const { t } = useLingui();

    const {
        logo, darkThemeLogo,

        logoSlim,
        siteName = "文档翻译",
        welcomeMessage,
        copyRight,

        sysVersion,
        showAutoRegisterTip = true,
        returnTo = "/",

        currentUserId,
        mobileHost,
        logonMethods = ["qrcode", "phone-code"],

        additionalMethodConfigs = {}

    } = props;

    const router = useRouter();

    const onSuccess = () => {
        router.push(returnTo);
    }

    async function loadUser() {
        const user = await getCurrentUser([]);
        console.log(">>> try to get user again", user);
        if (user) {
            onSuccess();
        }
    }


    useEffect(() => {
        if (currentUserId) {
            onSuccess()
        } else {
            // 再次尝试拿一下用户
            setTimeout(() => {
                loadUser()
            }, 100)
        }
    }, [currentUserId]);



    const track = useTrack();

    // method: phone-code, password, qrcode
    const [method, setMethod] = useState(
        // "qrcode",
        logonMethods[0]
    );

    // const methods = [
    //     { name: "phone-code", label: "手机验证码" },
    //     { name: "qrcode", label: "微信二维码" }
    // ];

    const methodConfigs = {
        "phone-code": {
            icon: <MdPhoneIphone />,
            label: t`验证码`,
            element: (
                <PhoneLogin {...{
                    onSuccess: _ => {
                        onSuccess()
                    }
                }} />
            )
        },
        "qrcode": {
            icon: <RiWechat2Line />,
            label: t`微信`,
            element: (
                <div className="flex flex-col items-center py-1 pb-2">
                    <WeChatLoginQrCode {...{
                        size: 160,
                        loadingElement: (
                            <div className="h-[198px] w-[160px]">
                            </div>
                        ),
                        showCountDown: true,
                        onSuccess: _ => {
                            onSuccess()
                        },
                        mobileHost,
                    }} />
                </div>
            )
        },
        "password": {
            icon: <RiLockPasswordLine />,
            label: t`密码`,
            element: (
                <PasswordLogin {...{
                    onSuccess: _ => {
                        onSuccess()
                    }
                }} />
            )
        },
        "saml": {
            icon: <RiShieldKeyholeLine />,
            label: "SSO",
            element: (
                <SamlLogin {...{
                    onSuccess: _ => {
                        onSuccess()
                    }
                }} />
            )
        },
        ...additionalMethodConfigs,
    }

    function renderLoginComponent() {
        const { element, Component } = methodConfigs[method];
        if (element) {
            return element
        }
        if (Component) {
            return (
                <Component {...{
                    // 
                    currentUserId,
                    onSuccess,
                }} />
            )
        }
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-between  sm:bg-[var(--mauve-2)] pt-8 sm:pt-0 pb-4 font-size-14">
            <div className="flex flex-col sm:justify-center grow w-full max-w-sm ">
                <div className="sm:shadow-xl rounded-lg flex flex-col py-12 px-6 sm:px-6 bg-[var(--lc-color-bg-1)] gap-6 transition-all">
                    <div className="flex flex-col gap-4 min-h-[48px] items-center px-6">
                        <div className="flex gap-2 flex sm:flex items-center">
                            {logo ? (
                                <>
                                    <img className="site-logo h-[34px] dark-only" src={getImageURL(darkThemeLogo, "medium")} />
                                    <img className="site-logo h-[34px] light-only" src={getImageURL(logo, "medium")} />
                                </>

                            ) : (
                                <>
                                    <img className="site-logo h-[38px]" src={getImageURL(logoSlim, "medium")} />
                                    <div className={clsx("font-medium", { "font-size-20": siteName.length <= 10, "font-size-18": siteName.length > 10 })}>
                                        {siteName}
                                        {sysVersion ? <span className="font-normal font-size-14 mx-2">{sysVersion}</span> : null}
                                    </div>
                                </>

                            )}
                        </div>
                        {welcomeMessage ? (
                            <div className="px-1">
                                {welcomeMessage}
                            </div>
                        ) : null}
                    </div>
                    <div className="flex flex-col gap-4 px-1.5 grow">
                        {renderLoginComponent()}
                    </div>
                    <div className="px-1.5 flex flex-col gap-3">
                        {
                            logonMethods.length > 1 ? (
                                <>
                                    <div className="flex gap-2 items-center px-4">
                                        <div className="h-px bg-[var(--mauve-6)] grow"></div>
                                        <div className="text-[--gray-9] font-size-13 self-center">{t`使用其他方式`}</div>
                                        <div className="h-px bg-[var(--mauve-6)] grow"></div>
                                    </div>
                                    <div className="flex gap-2 justify-center">
                                        {logonMethods.map(m => {
                                            if (m == method) {
                                                return null
                                            }
                                            const config = methodConfigs[m];
                                            const { label, icon } = config;

                                            return iconButton(icon, _ => {
                                                setMethod(m)
                                            }, { size: "normal", key: m })
                                        })}
                                    </div>
                                </>
                            ) : null
                        }
                        {showAutoRegisterTip ? <div className="font-size-13 text-[var(--gray-9)] pl-2 self-center">{t`首次登录会自动注册`}</div> : null}
                    </div>
                </div>
            </div>
            {copyRight ? (
                    <div className="font-size-12 text-[--gray-11]">{copyRight}</div>
                ) : <div className="h-8" />}
        </div>
    )
}


function PhoneLogin({ onSuccess }) {

    const { t } = useLingui();
    const track = useTrack();

    const [phoneNumber, setPhoneNumber] = useState("");
    const [veriCode, setVeriCode] = useState("");

    const [veriCodeSentForPhone, setVeriCodeSentForPhone] = useState({});

    const [veriCodeCountDown, setVerCodeCountDown] = useState(0);

    useEffect(() => {
        if (veriCodeCountDown > 0) {
            setTimeout(() => setVerCodeCountDown(prev => prev - 1), 1000)
        }
    }, [veriCodeCountDown])

    const [agreementChecked, setAgreementChecked] = useState(true);

    const isValidPhoneNumber = phoneNumber && /^\d{11}$/.test(phoneNumber);
    const isValidCode = !!(veriCode && /^\d{6}$/.test(veriCode));

    const isVeriCodeSent = veriCodeSentForPhone[phoneNumber] || true;

    const [errorMessage, setErrorMessage] = useState();

    useEffect(() => {
        setErrorMessage();
    }, [phoneNumber, veriCode]);

    const [veriCodeSending, setVeriCodeSending] = useState(false)
    async function sendVeriCode() {
        if (veriCodeCountDown > 0 || !isValidPhoneNumber) return null;

        setVeriCodeSending(true);
        const [result, error] = await add({
            entityName: "短信-发送验证码请求",
            formData: {
                手机号: phoneNumber
            },
            fieldPaths: []
        });
        setVeriCodeSending(false);

        if (!error && result) {
            setVeriCodeSentForPhone(prev => ({
                ...prev, [phoneNumber]: true
            }));
            setVerCodeCountDown(60);

        } else {
            toast({ title: error || t`出错了` })
        }
    }

    const [isSigningIn, setIsSigningIn] = useState(false)
    async function tryToRegisterOrSignIn() {
        setIsSigningIn(true);
        const [result, error] = await mobileLogin({ phoneNumber, verificationCode: veriCode, autoRegister: true });
        setIsSigningIn(false);

        if (!error && result) {
            const { errMessage, authSession } = result;
            if (errMessage) {
                setErrorMessage(errMessage);
            } else if (authSession) {
                const { authUser, token } = authSession;
                await setTokenCookie(token);

                onSuccess({
                    userId: authUser.id,
                    nickName: authUser.nickName,
                    phoneNumber,
                })
            }
            //
        } else {
            // 
            // TODO error handling
            toast({ title: error || t`出错了` })
        }
    }

    function convertErrorMessage(errorMessage) {
        if (errorMessage == "验证码已过期" || errorMessage == "验证码未发送" || errorMessage == "短信验证码已过期" || errorMessage == "短信验证码未发送") {
            return t`验证码不正确`
        } else {
            return errorMessage
        }

    }


    const [staticContentToShow, setStaticContentToShow] = useState();
    function renderModalLink(text, code) {
        return (
            <Pressable id={"link-to-" + code} onPress={_ => {
                // open modal
                track("logon_click_agreement_link", { "content_code": code });
                setStaticContentToShow(code);

            }}>
                <span className="text-[var(--violet-11)] cursor-pointer hover:underline mx-0.5">{text}</span>
            </Pressable>
        )
    }

    return (
        <>
            {/* 手机号，验证码，同意协议 */}
            <div className="flex flex-col gap-3 mt-1.5">
                <TextInput styled={true} color={"main"} className={"!p-3"} value={phoneNumber} onChange={setPhoneNumber} placeholder={t`输入您的手机号`} maxLength={11} autoFocus />
                <div className="flex gap-4 items-center">
                    <div className="grow">
                        <TextInput styled={true} color={"main"} className={"!p-3"} value={veriCode} onChange={setVeriCode} placeholder={t`输入验证码`} maxLength={6} />
                    </div>
                    <div className="h-full py-[0.5px]">
                        <Button className="!h-full !w-[108px] px-1" color={"main"}
                            id="btn-send-vericode"
                            isDisabled={!isValidPhoneNumber || veriCodeCountDown > 0}
                            isLoading={veriCodeSending}
                            onPress={_ => {
                                track("logon_send_vericode");
                                sendVeriCode()
                            }}
                        >
                            {veriCodeCountDown > 0 ? t`${veriCodeCountDown} 秒` : t`获取验证码`}
                        </Button>
                    </div>
                </div>
                <div className="h-[22px] -mt-2">
                    {errorMessage ? (
                        <div className="text-[var(--tomato-9)] px-2 font-size-13">{convertErrorMessage(errorMessage)}</div>
                    ) : null}
                </div>
            </div>
            <div className="flex flex-col gap-4 pb-1.5">
                {/* <div className="flex gap-1.5">
                    <div className="translate-y-1 sm:translate-y-[2px]">
                        <Checkbox color={"main"} checked={agreementChecked} onChange={checked => {
                            setAgreementChecked(checked);
                        }}></Checkbox>
                    </div>
                    <div className="font-size-13">我已阅读和同意 {renderModalLink("服务协议", "terms-of-service")}和{renderModalLink("隐私政策", "privacy-policy")}</div>
                </div> */}
                <div className="flex flex-col gap-3 mb-5">
                    <Button appearance="primary" color={"main"} size="xlarge" className="w-full"
                        isLoading={isSigningIn}
                        isDisabled={!(isValidPhoneNumber && isValidCode && agreementChecked && isVeriCodeSent) || errorMessage}
                        id="btn-register-phone"
                        onPress={_ => {
                            // try to register      
                            track("logon_register_phone");

                            tryToRegisterOrSignIn()

                        }}
                    >{t`登录账户`}</Button>
                </div>

            </div>
            {/* {renderMergeConfirmation()} */}
        </>
    )

}


function PasswordLogin({ onSuccess }) {

    const { t } = useLingui();
    const track = useTrack();

    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [errorMessage, setErrorMessage] = useState();

    useEffect(() => {
        setErrorMessage();
    }, [userName, password]);

    const isValidUserName = userName && userName.length > 2;
    const isValidPass = password && password.length > 2;

    async function submitPassword() {

        setIsSubmitting(true);
        const [result, error] = await passwordLogin({ userName, password });

        setIsSubmitting(false);

        if (!error && result) {
            const { errMessage, authSession } = result;

            if (errMessage) {
                setErrorMessage(errMessage);
            } else if (authSession) {
                const { authUser, token } = authSession;
                await setTokenCookie(token);
                onSuccess({
                    userId: authUser.id,
                    nickName: authUser.nickName,
                    // phoneNumber,
                })
            }

        } else {
            // 
            // TODO error handling
            toast({ title: error || t`出错了` })
        }
    }

    // console.log(">>>", userName, password, isValidUserName, isValidPass, errorMessage, !(isValidUserName && isValidPass) || errorMessage)

    // 用户名，密码
    return (
        <>
            <div className="flex flex-col gap-3 mt-1.5">
                <TextInput styled={true} color={"main"} className={"!p-3"} value={userName} onChange={setUserName} placeholder={t`输入您的用户名`} autoFocus />
                <PasswordInput styled={true} color={"main"} className={"!p-3"} value={password} onChange={setPassword} placeholder={t`输入密码`} />
                <div className="h-[22px] -mt-2">
                    {errorMessage ? (
                        <div className="text-[var(--tomato-9)] px-2 font-size-13">{errorMessage}</div>
                    ) : null}
                </div>
            </div>
            <div className="flex flex-col gap-4 pb-1.5">
                <div className="flex flex-col gap-3 mb-5">
                    <Button appearance="primary" color={"main"} size="xlarge" className="w-full"
                        isLoading={isSubmitting}
                        isDisabled={!(isValidUserName && isValidPass) || errorMessage}
                        id="btn-register-phone"
                        onPress={_ => {
                            // try to register      
                            track("logon_submit_password");
                            submitPassword()

                        }}
                    >{t`登录账户`}</Button>
                </div>
            </div>
            {/* {renderMergeConfirmation()} */}
        </>
    )
}